import { withAppBasename } from './appBase';

// App path -> the URL path to navigate to with window.location. Under
// ivoriai.com/edu the router basename does not cover raw navigations, so the
// /edu prefix is added here; on pathbuddy.com and the exam hosts it is a no-op.
export const getEduPortalUrl = (path = '') => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  if (typeof window === 'undefined') return cleanPath;
  return withAppBasename(cleanPath);
};

export const getBaseApiUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window !== 'undefined' && (window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1'))) {
    return 'http://127.0.0.1:5000';
  }
  // Same origin on lnat.ivori.ai / ivori.ai so JWT is sent to this app, not localhost. test push
  return '';
};

const isSpecialtyHost = () => {
  if (typeof window === 'undefined') return false;
  const h = (window.location.hostname || '').toLowerCase();
  return h.startsWith('lnat.') || h.includes('lnat.') ||
         h.startsWith('tmua.') || h.includes('tmua.') ||
         h.startsWith('ucat.') || h.includes('ucat.') ||
         h.startsWith('tara.') || h.includes('tara.') ||
         h.startsWith('esat.') || h.includes('esat.') ||
         h.startsWith('oxbridge.') || h.includes('oxbridge.') ||
         h.startsWith('medicalschool.') || h.includes('medicalschool.') ||
         h.startsWith('degreeapprenticeship.') || h.includes('degreeapprenticeship.') ||
         h.includes('ivoriai.com') || h.includes('ivoriedu.com') ||
         h.includes('ivori.ai') || h === 'pathbuddy.com' || h === 'www.pathbuddy.com' ||
         h.includes('localhost') || h.includes('127.0.0.1');
};

/**
 * Profile/settings fetches that talk to the same origin backend.
 */
export const getLnatSafeApiBase = (nonLnatFallback) => {
  if (isSpecialtyHost()) return getBaseApiUrl();
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  return nonLnatFallback || getBaseApiUrl();
};

// API Configuration
export const API_CONFIG = {
  baseURL: getBaseApiUrl(),
  timeout: 30000, // 30 seconds
  retryAttempts: 1, // Fast single retry
  retryDelay: 250, // 250ms fast delay
};

// API endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    LOGOUT: '/api/auth/logout',
    LOGOUT_ALL: '/api/auth/logout-all',
    REFRESH: '/api/auth/refresh',
    ME: '/api/auth/me',
    FORGOT_PASSWORD: '/api/auth/forgot-password',
    RESET_PASSWORD: '/api/auth/reset-password',
  },
  
  // User endpoints
  USER: {
    PROFILE: '/api/user/profile',
    AVATAR: '/api/user/avatar',
    CHANGE_PASSWORD: '/api/user/change-password',
  },
  
  // Quiz endpoints
  QUIZ: {
    EXAMS: '/api/quiz/exams',
    EXAM_TOPICS: (examId) => `/api/quiz/exams/${examId}/topics`,
    HEALTH: '/api/quiz/health',
  },
  
  // Interview endpoints
  INTERVIEW: {
    SESSIONS: '/api/interview/sessions',
    HEALTH: '/api/interview/health',
  },
  
  // Case study endpoints
  CASE_STUDY: {
    LIST: '/api/case-study/',
    DETAIL: (id) => `/api/case-study/${id}`,
    HEALTH: '/api/case-study/health',
  },
  
  // Apps endpoints
  APPS: {
    LIST: '/api/apps/',
    DETAIL: (id) => `/api/apps/${id}`,
    UPDATE: (id) => `/api/apps/${id}`,
    HEALTH: '/api/apps/health',
  },
  
  // Chat endpoints
  CHAT: {
    SESSIONS: '/api/chat/sessions',
    MESSAGES: (sessionId) => `/api/chat/sessions/${sessionId}/messages`,
    HEALTH: '/api/chat/health',
  },
  
  // Health check
  HEALTH: '/api/health',
};